<template>
  <div v-if="show" class="base-popup-overlay" @click="handleOverlayClick">
    <div class="base-popup-card" @click.stop>
      <!-- 關閉按鈕 (可選) -->
      <button v-if="showCloseButton" class="base-popup-close" @click="$emit('close')">
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_292_6835)">
            <path d="M20 0C8.95437 0 0 8.95437 0 20C0 31.0462 8.95437 40 20 40C31.0462 40 40 31.0462 40 20C40 8.95437 31.0462 0 20 0ZM20 37.5394C10.3506 37.5394 2.5 29.6494 2.5 19.9999C2.5 10.3505 10.3506 2.49992 20 2.49992C29.6494 2.49992 37.5 10.3506 37.5 19.9999C37.5 29.6493 29.6494 37.5394 20 37.5394ZM27.0706 12.9294C26.5825 12.4412 25.7913 12.4412 25.3031 12.9294L20 18.2325L14.6969 12.9294C14.2087 12.4412 13.4175 12.4412 12.9288 12.9294C12.4406 13.4175 12.4406 14.2087 12.9288 14.6969L18.2319 20L12.9288 25.3031C12.4406 25.7906 12.4406 26.5832 12.9288 27.0707C13.4169 27.5588 14.2081 27.5588 14.6969 27.0707L20 21.7675L25.3031 27.0707C25.7913 27.5588 26.5825 27.5588 27.0706 27.0707C27.5588 26.5832 27.5588 25.7906 27.0706 25.3031L21.7675 20L27.0706 14.6969C27.5594 14.2081 27.5594 13.4169 27.0706 12.9294Z" fill="white"/>
          </g>
          <defs>
            <clipPath id="clip0_292_6835">
              <rect width="40" height="40" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      </button>

      <!-- 內容區域 -->
      <div class="base-popup-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BasePopup',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    showCloseButton: {
      type: Boolean,
      default: true
    },
    closeOnOverlay: {
      type: Boolean,
      default: true
    },
    autoClose: {
      type: Number,
      default: 0 // 0 = 不自動關閉，其他數字為毫秒
    }
  },
  data() {
    return {
      autoCloseTimer: null
    }
  },
  watch: {
    show(newVal) {
      if (newVal && this.autoClose > 0) {
        this.startAutoClose()
      } else {
        this.clearAutoClose()
      }
    }
  },
  beforeDestroy() {
    this.clearAutoClose()
  },
  methods: {
    handleOverlayClick() {
      if (this.closeOnOverlay) {
        this.$emit('close')
      }
    },
    startAutoClose() {
      this.clearAutoClose()
      this.autoCloseTimer = setTimeout(() => {
        this.$emit('close')
      }, this.autoClose)
    },
    clearAutoClose() {
      if (this.autoCloseTimer) {
        clearTimeout(this.autoCloseTimer)
        this.autoCloseTimer = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.base-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.base-popup-card {
  background: #F3F3F3;
  border-radius: 16px;
  padding: 32px 16px;
  margin: 24px;
  position: relative;
  max-width: 320px;
  width: 90%;
  max-height: 90vh;
  overflow: visible;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);

  // 統一所有 popup 的基本樣式
  // 子組件只需要專注於內容，不需要覆蓋基本樣式
}

.base-popup-close {
  position: absolute;
  bottom: -64px;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 40px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

.base-popup-content {
  // 統一所有 popup 的文字樣式
  text-align: center;
}

// 統一 title 樣式
::v-deep .popup-title {
  color: #333333;
  font-weight: 700;
  font-size: 18px;
  line-height: 200%;
  letter-spacing: 0.1px;
  text-align: center;
  white-space: pre-line;
}

// 統一 description 樣式
::v-deep .popup-description {
  color: #999999;
  font-weight: 700;
  font-size: 14px;
  line-height: 200%;
  letter-spacing: 0.1px;
  text-align: center;
  white-space: pre-line;
}
</style>